import React from 'react';
import './styles.scss';
import { modalViewGA } from '../../../utils/googleAnalytics';

class WelcomeModal extends React.Component {
  constructor(props){
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state = {};
  }

  componentDidMount(){
    modalViewGA('welcome-modal');
  }

  closeModal(e){
    e.preventDefault();
    // Cookie.set('showed_welcome', 1);
    this.props.removeModal();
  }

  render(){
    return (
      <div>
        <div className="modals-popup welcome-modal">
          <div className="modal-header d-flex align-items-center">
            <div className="col">Welcome to the New Explore Website</div>
            <div className="text-right">
              <a className="closer" href="#" onClick={(e)=>{this.closeModal(e)}}></a>
            </div>
          </div>

          <div className="info">
            <div className="p-20">

              <div className="embed-responsive embed-responsive-16by9">
                <iframe
                  className="embed-responsive-item"
                  src="https://www.youtube.com/embed/UHAUe0YbXfA?autoplay=0&showinfo=0"
                  allowfullscreen>
                </iframe>
              </div>

              <div className="mt-10 text-center">

                <a href="https://files.explore.org/files/explore_website_tutorial.pdf" target="_blank">
                  <button className="community-guidelines text-uppercase video-player-btn text-btn u-font-foundation-roman">
                    <div>Download Website Tutorial PDF</div>
                  </button>
                </a>

                <a href="http://helpcenter.explore.org" target="_blank">
                  <button className="community-guidelines text-uppercase video-player-btn text-btn u-font-foundation-roman">
                    <div>Go to FAQs</div>
                  </button>
                </a>

              </div>

            </div>
          </div>

        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
  };
}

export default WelcomeModal;
